import { render, staticRenderFns } from "./vivoClaim.vue?vue&type=template&id=7597536c&scoped=true&"
import script from "./vivoClaim.vue?vue&type=script&lang=js&"
export * from "./vivoClaim.vue?vue&type=script&lang=js&"
import style0 from "./vivoClaim.vue?vue&type=style&index=0&id=7597536c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7597536c",
  null
  
)

export default component.exports